export const FIELDS = {
	NOM: { name: 'nom' },
	PRENOM: { name: 'prenom' },
	ACTIVE: { name: 'isActive', optional: true },
	TYPE_RESSOURCE: { name: 'typeRessource' },
	TYPE_CONTRAT: { name: 'typeContrat' },
	DEBUT_CONTRAT: { name: 'debutContrat' },
	FIN_CONTRAT: { name: 'finContrat', optional: true },
	IS_HOUR_DEPEND: { name: 'isHourDepend', optional: true },
	USER: { name: 'user' }
}